function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.819 6.134v1.921H5.87v3.043h3.792v1.887H5.872V18h-2.38V6.134h7.327zm5.78 11.985c-.828 0-1.573-.142-2.236-.425-.663-.283-1.187-.691-1.572-1.224-.386-.533-.584-1.162-.595-1.887h2.55c.034.487.206.873.518 1.156.312.283.74.425 1.284.425.555 0 .991-.133 1.309-.4a1.3 1.3 0 0 0 .476-1.045c0-.351-.108-.64-.323-.867a2.263 2.263 0 0 0-.808-.535c-.323-.13-.768-.275-1.335-.434-.77-.227-1.396-.45-1.878-.671a3.29 3.29 0 0 1-1.241-1.003c-.346-.448-.518-1.046-.518-1.794 0-.703.175-1.315.527-1.836.35-.521.844-.92 1.479-1.198.634-.278 1.36-.417 2.176-.417 1.224 0 2.218.297 2.983.892.765.596 1.187 1.426 1.267 2.491h-2.618a1.36 1.36 0 0 0-.519-1.011c-.323-.267-.75-.4-1.283-.4-.465 0-.836.119-1.114.357-.278.238-.416.584-.416 1.037 0 .317.104.58.314.79.21.21.47.38.782.51.312.13.75.281 1.318.451.77.227 1.4.453 1.887.68.487.227.906.567 1.258 1.02.35.453.527 1.048.527 1.785 0 .635-.165 1.224-.493 1.768-.33.544-.81.978-1.445 1.3-.635.324-1.389.485-2.261.485z",
  fill: "#323C47",
  fillRule: "nonzero"
});

var Svg8BaseFullStack = function Svg8BaseFullStack(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/8base-full-stack.a4a02955.svg";
export { Svg8BaseFullStack as ReactComponent };